export function isIncluded<T extends string>(
  arr: ReadonlyArray<T>,
  value: any
): value is T {
  if (typeof value !== "string") {
    return false;
  }
  return arr.includes(value as T);
}
